import { render, staticRenderFns } from "./BindsCardContent.vue?vue&type=template&id=3a21f817&"
import script from "./BindsCardContent.vue?vue&type=script&lang=js&"
export * from "./BindsCardContent.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardContent.vue?vue&type=style&index=0&id=3a21f817&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports